import Icon from '../../../components/AppIcon';

const IntegrationStatusPanel = () => {
  const integrationSystems = [
    {
      id: 1,
      name: 'ERP System',
      status: 'connected',
      lastSync: '2025-12-12 07:30:00',
      syncFrequency: '15 minutes',
      recordsSynced: 1247,
      icon: 'Database'
    },
    {
      id: 2,
      name: 'Banking System',
      status: 'connected',
      lastSync: '2025-12-12 07:25:00',
      syncFrequency: '30 minutes',
      recordsSynced: 89,
      icon: 'Banknote'
    },
    {
      id: 3,
      name: 'Shipping Database',
      status: 'warning',
      lastSync: '2025-12-12 06:45:00',
      syncFrequency: '1 hour',
      recordsSynced: 456,
      icon: 'Ship'
    },
    {
      id: 4,
      name: 'Customs System',
      status: 'connected',
      lastSync: '2025-12-12 07:15:00',
      syncFrequency: '2 hours',
      recordsSynced: 234,
      icon: 'FileCheck'
    },
    {
      id: 5,
      name: 'Platts Pricing',
      status: 'error',
      lastSync: '2025-12-11 23:30:00',
      syncFrequency: '4 hours',
      recordsSynced: 0,
      icon: 'TrendingUp'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'connected': return 'text-success';
      case 'warning': return 'text-warning';
      case 'error': return 'text-error';
      default: return 'text-muted-foreground';
    }
  };

  const getStatusBgColor = (status) => {
    switch (status) {
      case 'connected': return 'bg-success/10';
      case 'warning': return 'bg-warning/10';
      case 'error': return 'bg-error/10';
      default: return 'bg-muted';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'connected': return 'CheckCircle2';
      case 'warning': return 'AlertTriangle';
      case 'error': return 'XCircle';
      default: return 'Circle';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Icon name="Link" size={20} className="text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-foreground">Integration Status</h3>
            <p className="text-sm text-muted-foreground">External system synchronization health</p>
          </div>
        </div>
        <div className="flex items-center gap-2 px-3 py-2 bg-muted/50 rounded-md">
          <Icon name="Activity" size={16} className="text-success animate-pulse" />
          <span className="text-sm font-medium">Live Monitoring</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {integrationSystems?.map((system) => (
          <div
            key={system?.id}
            className="border border-border rounded-lg p-4 hover:shadow-md transition-shadow"
          >
            <div className="flex items-start justify-between mb-3">
              <div className="flex items-center gap-3">
                <div className={`w-10 h-10 rounded-lg ${getStatusBgColor(system?.status)} flex items-center justify-center`}>
                  <Icon name={system?.icon} size={20} className={getStatusColor(system?.status)} />
                </div>
                <div>
                  <h4 className="font-medium text-foreground">{system?.name}</h4>
                  <p className="text-xs text-muted-foreground">Sync: {system?.syncFrequency}</p>
                </div>
              </div>
              <Icon
                name={getStatusIcon(system?.status)}
                size={20}
                className={getStatusColor(system?.status)}
              />
            </div>

            <div className="space-y-2">
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Last Sync:</span>
                <span className="font-medium">{system?.lastSync}</span>
              </div>
              <div className="flex items-center justify-between text-sm">
                <span className="text-muted-foreground">Records:</span>
                <span className="font-medium">{system?.recordsSynced?.toLocaleString()}</span>
              </div>
            </div>

            <div className="mt-3 pt-3 border-t border-border">
              <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium ${
                system?.status === 'connected' ?'bg-success/10 text-success'
                  : system?.status === 'warning' ?'bg-warning/10 text-warning' :'bg-error/10 text-error'
              }`}>
                <span className={`w-1.5 h-1.5 rounded-full ${
                  system?.status === 'connected' ? 'bg-success animate-pulse' :
                  system?.status === 'warning' ? 'bg-warning' : 'bg-error'
                }`} />
                {system?.status}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IntegrationStatusPanel;